import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from 'react';
import { Table, Form } from 'antd';
import EditableCell from './editableCell';

export const EditableContext = React.createContext();

const EditableTable = (props, ref) => {
  const { dataSource, isEditing, columns, highlightedColIndex, compData } =
    props;

  const [tableDataSource, setTableDataSource] = useState(dataSource);
  const [form] = Form.useForm();
  const EditableRow = [3, 4, 5];
  const [presetRows, setPresetRows] = useState([]);

  const isEditableRow = (index) => EditableRow.includes(index);

  useImperativeHandle(ref, () => ({
    retrieveData: () => tableDataSource.filter((_, i) => isEditableRow(i)),
    // cancelEdit: () => setEditableRow([3, 4, 5])
  }));

  const toggleRowIsPreset = (isPreset) => (rIndex) => {
    if (!isPreset) {
      setPresetRows((old) => [...old].filter((i) => i !== rIndex));
    } else {
      setPresetRows((old) =>
        [...old, rIndex].filter((e, i, a) => a.indexOf(e) === i),
      );
    }
  };

  const isPresetNumber = (col, rowIndex) =>
    !col.isNumber || !presetRows.includes(rowIndex);

  useEffect(() => {
    setTableDataSource(dataSource);
    setPresetRows([]);
  }, [dataSource]);

  const components = {
    body: {
      cell: EditableCell,
    },
  };

  const handleSave = (row) => {
    const newData = [...tableDataSource];
    const index = row.rowIndex;
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row, key: index });
    setTableDataSource(newData);
  };

  const columnsInTable = isEditing
    ? columns.map((col, i) => ({
        ...col,
        className: i === highlightedColIndex ? 'highlighted-col' : '',
        onCell: (record, rowIndex) => ({
          record,
          editable: isEditableRow(rowIndex) && isPresetNumber(col, rowIndex),
          dataIndex: col.dataIndex,
          title: col.title,
          rule: col.rule,
          rowIndex,
          isNumber: col.isNumber,
          isHighlighted: i === highlightedColIndex,
          handleSave,
          compData,
          toggleRowIsPreset,
          // toggleRowEditable,
        }),
      }))
    : columns.map((col, i) => ({
        ...col,
        className: i === highlightedColIndex ? 'highlighted-col' : '',
      }));
  return (
    <Form form={form} component={false} autoComplete="off">
      <EditableContext.Provider value={form}>
        <Table
          components={isEditing && components}
          dataSource={tableDataSource}
          columns={columnsInTable}
          pagination={false}
        />
      </EditableContext.Provider>
    </Form>
  );
};

export default forwardRef((props, ref) => EditableTable(props, ref));
